import { Expose, Transform } from "class-transformer";

export class SaveInvoiceLineDto {
  @Expose()
  id?: string;

  @Expose()
  intervention: string;

  @Expose()
  text: string;

  @Expose()
  @Transform(({ value }) => Number(value))
  quantity: number;

  @Expose()
  operativeUnitId?: string | null;

  @Expose()
  position: number;
}
